var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary d-flex"},[_c('div',{staticClass:"statistic d-flex flex-grow-1 px-3 justify-content-between"},[_c('div',{},[_c('span',[_vm._v(_vm._s(_vm.$t("unit.total")))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.total))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }